
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';

const SingleAccountDetails = () => {
  const { accountId } = useParams();
  const decodedId = accountId ? atob(accountId) : accountId;
  const id = decodedId.replace(/\D/g, ''); // Ensure we only get the numeric part
  const [accountDetails, setAccountDetails] = useState(null);

  const [columns, setColumnDetails] = useState([]);

  useEffect(() => {
    const fetchAccountDetails = async () => {
      try {
        const response = await axios.get(`${API_DOMAIN}${API_ROUTES.account}${id}/`, { headers });
        const extractedColumns = Object.keys(response.data);
       
        const parentAccountId = response.data.parent_account;
        //console.log(parentAccountId)
        if (parentAccountId) {
          const parentResponse = await axios.get(`${API_DOMAIN}${API_ROUTES.account}${parentAccountId}/`, { headers });
          const parentAccountDetails = parentResponse.data;          
          extractedColumns.push('Parent Account Name');          
          response.data['Parent Account Name'] = parentAccountDetails.name; 
         
        } 
      
      // Define which columns to exclude (if necessary)
        const excludedColumns = ['id', 'created_at', 'updated_at', 'parent_account'];
        const columnsArray = extractedColumns
          .filter((column) => !excludedColumns.includes(column))
          .map((column) => ({
            label: column.charAt(0).toUpperCase() + column.slice(1).replace('_', ' '),
            field: column,
          }));

        setColumnDetails(columnsArray);
        setAccountDetails(response.data);
      } catch (error) {
        console.error('Error fetching account details:', error);
      }
    };

    fetchAccountDetails();
  }, [accountId]);
  

  return (
    <div>
      {accountDetails ? (
        <SingleItemDetailTemplate details={accountDetails} columns={columns} />
      ) : (
        <p>Loading account details...</p>
      )}
    </div>
  );
};

export default SingleAccountDetails;
